module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_big.207394a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_big.jpg
// module id = 2888
// module chunks = 11